var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: { enabled: true },
          expression: "{ enabled: true }",
        },
      ],
      staticClass: "is-flex",
      attrs: { content: _vm.fullName },
    },
    [
      _vm.isTextProfile
        ? _c("svg-circle", {
            attrs: {
              name: "userProfile",
              text: _vm.initials,
              width: _vm.width,
              height: _vm.height,
            },
          })
        : _c("img", {
            staticClass: "is-rounded",
            style: `width: ${_vm.width}px;`,
            attrs: {
              name: "userProfileIcon",
              src: _vm.base64Image,
              "aria-haspopup": "true",
              "aria-expanded": "false",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }